import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { map, switchMap } from 'rxjs/operators';
import { PostService } from '../../../services/post-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Translatable } from '../../../models/translatable.model';
import { Media } from '../../../models/media.model';
import { LocalDatePipe } from '../../../shared/pipes/local-date-pipe';
import { Post } from '../../../models/post.model';
import { Category } from '../../../models/category.model';
import { Observable } from 'rxjs';
import { SidebarBlog } from "../sidebar-blog/sidebar-blog";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LightboxComponent } from '../../../shared/components/lightbox/lightbox.component';
import { LightboxMedia } from '../../../shared/components/lightbox/lightbox.model';
import { Loading } from "../../layouts/loading/loading";
declare var $: any;

@Component({
  selector: 'app-article-component',
  imports: [CommonModule, TranslateModule, LocalDatePipe, RouterModule, SidebarBlog, CarouselModule, Loading, LightboxComponent],
  providers: [DatePipe],
  templateUrl: './article-component.html',
  styleUrl: './article-component.css',
})
export class ArticleComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private articleService = inject(PostService);
  //lastest:Post[]= [];
  customOptions: any = {
    loop: true,
    margin: 10,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 700,
    nav: false,
    autoplay: true,
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 2
      },
      992: {
        items: 3
      }
    }
  };
  
  lastest$: Observable<Post[]> = this.articleService.getArticles(1, 6).pipe(
      map(res => res.data)
    );
  categories:Category[]= [];

  constructor(
    private translate: TranslateService,
    private datePipe: DatePipe, 
  ) {}

  ngOnInit(): void {
    //console.log( this.route.snapshot.paramMap.get('slug'));
  }
  ngOnDestroy(): void {
    
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $('.img-popup').magnificPopup({
        type: 'image',
        gallery: {
          enabled: true
        }
      });
    }, 500);
  }
  article$:Observable<Post> = this.route.paramMap.pipe(
    switchMap((params) => this.articleService.getArticle(params.get('slug')!)),
    map(res => res.data) 
  );

  formatDate(value: string): string {
    return this.datePipe.transform(value, 'dd MMM, yy', undefined, 'fr-FR') ?? '';
  }

  translateField(field: Translatable) {
    const lang = this.translate.getCurrentLang();
    if(field){
      switch (lang) {
        case 'fr':
          return field.fr;
        case 'en':
          return field.en;
        case 'ar':
          return field.ar;
        default:
          return field.fr;
      }
    }else return '';
  }

  loadImageFeatured(imageUrl: Media | null | undefined) {
    //console.log(imageUrl);
    return imageUrl ? imageUrl.url : '/assets/images/default_image.png';
  }

  /**
   * Palier de taille du titre de bannière.
   *
   * `clamp()` seul ne suffit pas : il fait varier la taille avec la largeur
   * de la fenêtre, mais pas avec la longueur du titre. Un titre long reste
   * donc affiché en grand et déborde de la bannière. On choisit ici un
   * palier d'après le nombre de caractères, que le CSS combine ensuite avec
   * `clamp()` pour rester responsive.
   */
  titleSizeClass(title: string | null | undefined): string {
    const length = (title ?? '').trim().length;

    if (length > 110) return 'titre--xs';
    if (length > 70)  return 'titre--sm';
    if (length > 40)  return 'titre--md';
    return 'titre--lg';
  }

  // ── Visionneuse de la galerie de l'article ──────────────────────────
  lightboxOpen  = false;
  lightboxIndex = 0;

  /**
   * Médias affichés par la visionneuse.
   *
   * L'article n'est disponible que sous forme de flux (`article$`) : la
   * galerie est donc transmise par le gabarit au moment de l'ouverture.
   */
  lightboxMedia: LightboxMedia[] = [];

  openLightbox(index: number, gallery: any[] | null | undefined, event?: Event): void {
    event?.preventDefault();

    this.lightboxMedia = (gallery ?? []).map((m: any) => ({
      url:       m?.url ?? '',
      thumb:     m?.thumb,
      mime_type: m?.mime_type,
    }));

    this.lightboxIndex = index;
    this.lightboxOpen  = true;
  }

  getDelay(i: number): string {
    return `${(i + 1) * 100}ms`;
  }
}
